<script lang="ts">
  // "← Back" link above a page title or in a form flow.
  //   <BackLink href="/app/klanten" label={t('nav.clients')} />
  //   <BackLink onclick={() => (step = 1)} />          button (wizards); default label "Terug"
  import { ArrowLeft } from '@lucide/svelte';
  import '../messages/ui';
  import { t } from '../i18n.svelte';

  interface Props {
    href?: string;
    label?: string;
    onclick?: (event: MouseEvent) => void;
    class?: string;
  }
  let { href, label, onclick, class: cls = '' }: Props = $props();
</script>

{#if href}
  <a class="back {cls}" {href} {onclick}><ArrowLeft aria-hidden="true" /><span>{label ?? t('ui.back')}</span></a>
{:else}
  <button type="button" class="back {cls}" {onclick}><ArrowLeft aria-hidden="true" /><span>{label ?? t('ui.back')}</span></button>
{/if}

<style>
  .back {
    display: inline-flex;
    align-items: center;
    gap: var(--space-1_5);
    align-self: flex-start;
    max-width: 100%;
    padding: var(--space-1) var(--space-2) var(--space-1) var(--space-1);
    margin-left: calc(var(--space-1) * -1);
    border: 0;
    border-radius: var(--radius-pill);
    background: none;
    color: var(--text-2);
    font-size: var(--text-sm);
    font-weight: var(--weight-medium);
    text-decoration: none;
    transition: color var(--dur), background var(--dur);
  }
  .back :global(svg) { width: var(--icon-md); height: var(--icon-md); transition: transform var(--dur) var(--ease); }
  .back span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .back:hover { color: var(--text); background: var(--surface-hover); text-decoration: none; }
  .back:hover :global(svg) { transform: translateX(-2px); }
  .back:focus-visible { outline: none; box-shadow: var(--ring); }
</style>
